import { lazy } from "react";
import { ProtectedRoute } from "../components/ProtectedRoute";
import PasswordContextProvider from "../contexts/PasswordContext";

const auditingRouteConfig = [
  {
    parent: {
      exact: true,
      path: "/audit/inspect-voucher",
      element: ProtectedRoute,
      permission_id: 3,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/inspecting/DocumentInspecting")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/audit/chequing",
      element: ProtectedRoute,
      permission_id: 5,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/auditing/DocumentAuditing")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/audit/return/audited-cheque",
      element: ProtectedRoute,
      permission_id: 5,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/auditing/returned/ReturnedDocument.jsx")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/audit/monitor/audit-chequing",
      element: ProtectedRoute,
      permission_id: 36,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/auditing/DocumentAuditing")),
      wrapper: PasswordContextProvider,
    },
  },
];

export default auditingRouteConfig;
